import { render } from "./FoodsChart.vue?vue&type=template&id=aec25624&scoped=true"
import script from "./FoodsChart.vue?vue&type=script&lang=js"
export * from "./FoodsChart.vue?vue&type=script&lang=js"

import "./FoodsChart.vue?vue&type=style&index=0&id=aec25624&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aec25624"]])

export default __exports__